import React from "react"

import Header from './product/Header'
import ProductLine from './product/ProductLine'
import Carousel from './product/Carousel'
import ProductDetail from './product/ProductDetail'


export default function Product() {
    const products = require('./product/products.json')
    const [productIndex, setProductIndex] = React.useState(undefined)

    return (
        <div>        
            <Header
                tapLogo={() => {setProductIndex(undefined)}}
            />
            <ProductLine
                selectProduct={(index) => setProductIndex(index)}
            />
            {
                productIndex === undefined ? 
                    <Carousel/> : 
                    <ProductDetail product={products[productIndex]}/>
            }                        
        </div>
    )
}